import {
  DensityMediumIcon,
  HelpIcon,
  Tooltip,
  Avatar,
  Popover,
  useStatefulRef,
} from "@forge/common";
import "./header.scss";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPermissions } from "../../../../../store/action";
import AuthProvider from "../../../../../../common/authentication/authService";
import { AppState } from "../../../../../../common/store/combinedReducer";
import { useNavigate } from "react-router-dom";
import { btnResponsive } from "../../utils/helper";
import useResponsiveSize from "../../utils/useWindowSize";
import AboutUsPopup from "../../../../../../common/components/AboutUsPopup/AboutUsPopup";
import { ABOUT_US } from "./constants";

interface HeaderProps {
  handleClickHam: () => void;
}

const Header: React.FC<HeaderProps> = ({ handleClickHam }) => {
  const anchor = useStatefulRef<HTMLDivElement>();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOpenHelpModal, setIsOpenHelpModal] = useState<boolean>(true);
  const [aboutUsPopOpen, setAboutUsPopOpen] = useState(false);

  const userInfo = useSelector((state: any) => {
    return state.reducer.userInfo;
  });

  const csrf = useSelector((state: AppState) => {
    return state.reducer.csrf;
  });

  useEffect(() => {
    if (localStorage.getItem("access_token") !== null) {
      const sub: any = AuthProvider().getUserId();
      if (sub) {
        if (!userInfo || !userInfo.hasOwnProperty("name")) {
          dispatch(
            getPermissions({
              userSub: sub,
              authorization: localStorage.getItem("access_token"),
            }),
          );
        }
      } else if (csrf === false) {
        setTimeout(() => {
          localStorage.setItem("logged_out_from", "academy header 55");
          navigate("/");
        }, 500);
      }
    } else {
      setTimeout(() => {
        localStorage.setItem("logged_out_from", "academy header 62");

        navigate("/");
      }, 500);
    }
  }, []);

  const handlenavigateToHelp = () => {
    window.open(
      "/helpservice/Content/Academy/Content/Resources/Station_Help_Landing_Pages/Home_for_HA_UG.htm",
      "_blank",
    );
  };

  const aboutUsPopup = () => {
    return (
      <AboutUsPopup
        heading={ABOUT_US.heading}
        version={ABOUT_US.version}
        patent={ABOUT_US.pat}
        onClose={() => setAboutUsPopOpen(false)}
      />
    );
  };

  return (
    <div className="flex gap-2 header mb-1">
      <DensityMediumIcon
        id="acc-header-id"
        data-testid="acc-header-id"
        className={`cursor-pointer hamburgerIcon ${btnResponsive(
          "panel-icons",
        )}`}
        onClick={handleClickHam}
      />
      <div className="flex space-x-2">
        <Tooltip content="Digital Prime Twin User Assistance" position="bottom">
          <HelpIcon
            id="help-icon-id"
            data-testid="help-icon-id"
            className={`cursor-pointer !text-[35px] xl-low!:text-[40px] xl-mid:!text-[40px] xl-high:!text-[45px]`}
            onClick={handlenavigateToHelp}
          />
        </Tooltip>
        <div ref={anchor} className="w-min" style={{ borderRadius: "100%" }}>
          <Avatar
            interactive
            size={useResponsiveSize() === "regular" ? "md" : "lg"}
            aria-label="profile"
            text={userInfo?.name ? userInfo.name.charAt(0).toUpperCase() : ""}
          />
          <Popover
            id="popover-t"
            position="top"
            anchor={anchor}
            attachEvent={true}
            anchorActiveClassName="active"
          >
            <div
              data-testid="profile-popover"
              className="h-auto dark:border-gray-410 dark:bg-container-dark popover-options"
            >
              <p data-testid="user-name" className="userData">
                {userInfo?.name}
              </p>
              <p
                id="about-us-link-id"
                data-testid="about-us-link"
                className="cursor-pointer text-white"
                onClick={() => setAboutUsPopOpen(true)}
              >
                About Us
              </p>
              <p
                id="logout-link"
                data-testid="logout-link"
                className="cursor-pointer text-white"
                onClick={() => {
                  localStorage.setItem("logged_out_from", "academy header");
                  navigate("/logout");
                }}
              >
                Log Out
              </p>
            </div>
          </Popover>
        </div>
      </div>
      {aboutUsPopOpen && (
        <div className="aboutus-overlay">{aboutUsPopup()}</div>
      )}
    </div>
  );
};
export default Header;
